import { render, staticRenderFns } from "./optionalInfo.vue?vue&type=template&id=68c8d452&scoped=true&"
import script from "./optionalInfo.vue?vue&type=script&lang=js&"
export * from "./optionalInfo.vue?vue&type=script&lang=js&"
import style0 from "./optionalInfo.vue?vue&type=style&index=0&id=68c8d452&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c8d452",
  null
  
)

export default component.exports